import React, { useEffect , useState } from "react";
import Head from "../layout/head/Head";
import Content from "../layout/content/Content";
import RecentOrders from "../components/partials/default/recent-orders/RecentOrders";
import DataCard from "../components/partials/default/DataCard";
import { PieChartExample , PreviewCard } from "../components/Component";
import exportFromJSON from "export-from-json";
import axios from "axios";
import { API_URL } from "../constent";
import { Collapse, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  BlockBetween,
} from "../components/Component";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Homepage = () => {
  const [sm, updateSm] = useState(false);
  const [homedata, Sethomedata] = useState(false);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [renuwal, setRenuwal] = useState('');
  const [doughnutChartData , setDoughnutChartData] = useState([]);
  const [CRMChartData , setCRMChartData] = useState([]);
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState("1");
  const [totalpremium, setTotalPremium] = useState(0);

  const [activeTab , setActivetab] = useState(0);

  const toggle = (tab) => {
    if (activeTab !== tab) setActivetab(tab);
  };


 
  var userData = JSON.parse(localStorage.getItem('userData'));
  var getuserid = userData?.[0]?.id;
  var role = userData?.[0]?.role;
  
  useEffect(()=>{
    
    axios.get(`${API_URL}getdashbord/${getuserid}`).then((result)=>
    {
        console.log(result.data);
        Sethomedata(result.data)
        setDoughnutChartData(result.data.doughnutChartData);
        setCRMChartData(result.data.CRMChartData);
        setLoading(false);
    }) 

    axios.get(`${API_URL}getmainsheet_desh/${getuserid}`).then((result)=>
      {
          console.log(result.data);
          setData(result.data);
          console.log(result.data.length);
          setLoading(false);
      })

    axios.get(`${API_URL}gettotalpremium`).then((result)=>
      {
          console.log(result.data['total_premium']);
          setTotalPremium(result.data['total_premium']);
          setLoading(false);
      }) 


},[])

const fileName = "user-data";
const exportExcel = () => {
  const exportType = exportFromJSON.types.xls;
  exportFromJSON({ data, fileName, exportType });
};

function Getcategory(type){

  setLoading(true);
  setRenuwal(type);

  axios.post(`${API_URL}getcategory`).then((result)=>
    {
        console.log(result.data);
        setCategory(result.data)
        setLoading(false);
    })
}

if (loading) {
  return(
     <>
       <p>Loading....</p>
     </>
  ) 
} 


  return (
    <React.Fragment>
      <Head title="Homepage"></Head>
      <Content>
        <Row className="g-gs">
            <Col  xxl="3" sm="4">
              <Link className="deshcss" to="/searchlist">Search</Link>
            </Col>
            <Col xxl="3" sm="4">
            <Link className="deshcss" to="/category">Add</Link>
            </Col>
            <Col xxl="3" sm="4">
              <Link className="deshcss" to="/reminder">REMINDER</Link>
            </Col>

            <Col xxl="3" sm="4">
             <p className="deshcss mb-0">Total Premium : INR {totalpremium}</p>
            </Col>

        </Row>
      </Content>
    </React.Fragment>
  );
};
export default Homepage;
